import React from "react";
import { motion } from "framer-motion";
import { Factory, FlaskConical } from "lucide-react";

export default function Facilities() {
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const facilities = [
    {
      name: "MAC LABS LIMITED: UNIT-I",
      description:
        "Equipped with state-of-the-art production lines for APIs, intermediates, UV filters, and specialty fine chemicals. Designed with robust safety systems, energy-efficient operations, and compliant with stringent international quality standards and with scalable production capabilities to meet customized requirements. The plant features high-capacity reactors and advanced multi-purpose production blocks.",
      accreditation: "ISO 9001:2015, GMP certified",
      reactor: "50",
      volume: "200 KL",
      address:
        "Plot No. 282, 283 & 284, KIADB, Kolhar Industrial Area, Bidar, Karnataka - India",
      icon: <Factory className="w-6 h-6 text-blue-600" />,
    },
    {
      name: "MAC LABS LIMITED: UNIT-II",
      description:
        "Specialized and dedicated to the production of high-quality Active Pharmaceutical Ingredients (APIs) and intermediates. The facility’s location offers exceptional connectivity to major highways, ports, and airports, enabling smooth and cost-effective logistics for both domestic distribution and international exports.",
      reactor: "30",
      volume: "100 KL",
      address:
        "Plot No. 103D, Sri Venkateswara Industrial Estate, IDA Bollaram, Telangana - India",
      icon: <FlaskConical className="w-6 h-6 text-green-600" />,
    },
  ];

  return (
    <div>
      {/* ✅ Hero Banner */}
      <div
        className="relative h-[300px] md:h-[400px] w-full bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage: "url('/images/facilities.webp')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
        <h1 className="relative text-4xl md:text-5xl font-bold text-white text-center">
          Facilities
        </h1>
      </div>

      {/* ✅ Facilities grid */}
      <motion.section
        id="facilities"
        className="max-w-6xl mx-auto px-6 py-12"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={container}
      >
        <motion.div className="grid md:grid-cols-2 gap-8" variants={fadeInUp}>
          {facilities.map((facility, index) => (
            <motion.div
              key={index}
              className="p-6 border rounded-lg shadow-sm hover:shadow-xl transition duration-300 bg-white"
              variants={fadeInUp}
            >
              <div className="flex items-center gap-2 mb-2">
                {facility.icon}
                <h2 className="text-xl font-semibold text-gray-800">
                  {facility.name}
                </h2>
              </div>
              <p className="text-gray-700 mb-4">{facility.description}</p>
              {facility.accreditation && (
                <p className="text-gray-600">
                  <strong>Facility Accreditation:</strong>{" "}
                  {facility.accreditation}
                </p>
              )}
              <p className="text-gray-600">
                <strong>Reactor Capacity:</strong> {facility.reactor}
              </p>
              <p className="text-gray-600">
                <strong>Total Volume:</strong> {facility.volume}
              </p>
              <p className="text-gray-600">
                <strong>Address:</strong> {facility.address}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </motion.section>
    </div>
  );
}
